/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralRecipientInput
 */
export interface ReferralRecipientInput {
    /**
     * 
     * @type {number}
     * @memberof ReferralRecipientInput
     */
    organization_id: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralRecipientInput
     */
    facility_id: number;
}

/**
 * Check if a given object implements the ReferralRecipientInput interface.
 */
export function instanceOfReferralRecipientInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "facility_id" in value;

    return isInstance;
}

export function ReferralRecipientInputFromJSON(json: any): ReferralRecipientInput {
    return ReferralRecipientInputFromJSONTyped(json, false);
}

export function ReferralRecipientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRecipientInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'facility_id': json['facility_id'],
    };
}

export function ReferralRecipientInputToJSON(value?: ReferralRecipientInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organization_id,
        'facility_id': value.facility_id,
    };
}

